var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIconYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 39918"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6193",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "#dfaa0c"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 61900",
    d: "M5.46 10a1.3 1.3 0 0 1-.31-1 3.25 3.25 0 0 1 .08-.69L6 4.92h1.48l-.8 3.62a2 2 0 0 0 0 .35.38.38 0 0 0 .11.3.5.5 0 0 0 .33.09.8.8 0 0 0 .34-.07A1.11 1.11 0 0 1 7 10a1.15 1.15 0 0 1-.8.28 1.08 1.08 0 0 1-.74-.28Zm.94-5.89a.84.84 0 0 1 0-1.19.84.84 0 0 1 .6-.26.86.86 0 0 1 .86.85.84.84 0 0 1-.86.84.81.81 0 0 1-.6-.24Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconYellow);
export default __webpack_public_path__ + "static/media/Info_Icon_Yellow.733a0d7a67e29deb93bd51ddbd48d086.svg";
export { ForwardRef as ReactComponent };